/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegationBatchResponse {
    getFixupPrototypeFunction() { return UserDelegationBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<UserDelegationBatchResponse>): UserDelegationBatchResponse {
        let obj = Object.assign(new UserDelegationBatchResponse(), model);
        UserDelegationBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegationBatchResponse>): UserDelegationBatchResponse {
        if (!model) return null;
        return UserDelegationBatchResponse.newInstance(<UserDelegationBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegationBatchResponse) {
        if (!obj) return;

        models.UserDelegationBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegationBatchResponse): boolean {
        Object.setPrototypeOf(obj, UserDelegationBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.UserDelegation.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.UserDelegation; };

}
